/**
 * The HOC is used to generate row data for non-group summary row.
 * @author: Ronan
 * @param: sourceProp {string} prop that needs to be processed. Normally, data in this prop should be column definitions.
 * @param: targetProp {string} prop that passed to WrappedComponent
 */
import React, { PureComponent } from 'react';
import Enums from 'utils/EnumsManager';
import { calcValueByType } from '../utils/index';

const { MAXROWS } = Enums.REPORTS.PREVIEW;

const produceRowData = (sourceProp, targetProp) => WrappedComponent =>
  class extends PureComponent {
    render() {
      if (!_.isArray(this.props[sourceProp])) return null;

      const rows = [];
      for (let i = 0; i < MAXROWS; i++) {
        let row = {};
        this.props[sourceProp].forEach(
          col => (row[col.name] = calcValueByType(col.type))
        );
        rows.push(row);
      }
      const props = {
        ...this.props,
        [targetProp]: rows
      };

      return <WrappedComponent {...props} />;
    }
  };

export default produceRowData;



// WEBPACK FOOTER //
// ./src/views/ReportPreview/HOCs/produceRowData.jsx